export const image = {
	default: 'https://storage.googleapis.com/master-image-bucket/react-product/placeholdermed.png',
};
